import Alpine from "../alpine.js"
import Chart from "chart.js/auto"

Alpine.data("wheelOfLifeChart", ({ labels, datasets, datasetAId, datasetBId }) => ({
  labels,
  datasets,
  datasetAId,
  datasetBId,
  init() {
    this.chooseDatasetA(datasetAId)
    if (datasetBId) {
      this.chooseDatasetB(datasetBId)
    }

    this.$nextTick(() => {
      let chart = new Chart(this.$refs.canvas.getContext("2d"), {
        type: "radar",
        data: {
          labels: this.labels,
          datasets: this.selectedDatasets(),
        },
        options: {
          scales: {
            r: { suggestedMin: 0, suggestedMax: 10 }
          },
          plugins: {
            legend: { display: false },
            tooltip: {
              displayColors: false
            }
          }
        }
      })

      this.$watch("datasetA", () => {
        chart.data.labels = this.labels
        chart.data.datasets = [this.datasetA, this.datasetB]
        chart.update()
      })
      this.$watch("datasetB", () => {
        chart.data.labels = this.labels
        chart.data.datasets = [this.datasetA, this.datasetB]
        chart.update()
      })
    })
  },
  selectedDatasets () {
    const selected = []
    if (this.datasetA) {
      selected.push(this.datasetA)
    }

    if (this.datasetB) {
      selected.push(this.datasetB)
    }

    return selected
  },
  chooseDatasetA (id) {
    let newDataset = this.datasets.find((d) => { return d.id === parseInt(id) })

    this.datasetA = {
      label: newDataset.label,
      data: newDataset.data,
      fill: true,
      backgroundColor: "rgba(55, 226, 148, 0.2)",
      borderColor: "#37E294",
      pointBackgroundColor: "#37E294"
    }
  },
  chooseDatasetB (id) {
    let newDataset = this.datasets.find((d) => { return d.id === parseInt(id) })

    this.datasetB = {
      label: newDataset.label,
      data: newDataset.data,
      fill: true,
      backgroundColor: "rgba(245, 46, 85, 0.2)",
      borderColor: "#F52E55",
      pointBackgroundColor: "#F52E55"
    }
  }
}))
